import { render, staticRenderFns } from "./InquiryManagementDetail.vue?vue&type=template&id=a9227248&"
import script from "./InquiryManagementDetail.vue?vue&type=script&lang=js&"
export * from "./InquiryManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./InquiryManagementDetail.vue?vue&type=style&index=0&id=a9227248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports